import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import {
  isEntityAdminPathMapped,
  isEntityPathMapped,
  RideCrudModeKey,
  RydeAppUnit,
  selectedSingleRowRideIdAtom,
  selectedTableRowsIdsAtomFamily,
} from "@ryde/shared";

import { usePageContext } from "../contexts";
import { useCrudNavigate } from "./use-crud-navigate";
import { useCrudNavigateAdmin } from "./use-crud-navigate.admin";
import { useRidesNavigation } from "./use-rides-navigation";

export const useCrudClickToEdit = () => {
  const { entity } = usePageContext();
  const { navigateToEdit } = useCrudNavigate(entity as RydeAppUnit);
  const { navigateToEdit: navigateToEditAdmin } = useCrudNavigateAdmin(
    isEntityAdminPathMapped(entity) ? entity : "unknown",
  );
  const { isGridSingleSelectView } = useRidesNavigation();
  const setSelectedSingleRowRideId = useSetRecoilState(
    selectedSingleRowRideIdAtom,
  );
  const setRideGridSelectedIds = useSetRecoilState(
    selectedTableRowsIdsAtomFamily(RideCrudModeKey.uiUnit),
  );

  const handleCrudClickToEdit = useEvent((id: number) => {
    if (entity === "ride" && isGridSingleSelectView) {
      setSelectedSingleRowRideId(id);
      setRideGridSelectedIds([id]);
    }

    if (!isEntityPathMapped(entity) && isEntityAdminPathMapped(entity)) {
      return navigateToEditAdmin(+id);
    }

    navigateToEdit(+id);
  });

  return { handleCrudClickToEdit };
};
